import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes/dist/types';
import React from 'react';
export const ThemeProvider = React.forwardRef<HTMLDivElement, ThemeProviderProps>(({
  children,
  ...props
}, _) => <NextThemesProvider {...props}>{children}</NextThemesProvider>);
ThemeProvider.displayName = 'ThemeProvider';